export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7947.3b69ad81.jpg";